<!--
File: product-details.component.html
Project: catalog-cloud
File Created: Thursday, 17th February 2022 11:48:25
Author: Tomás Muniesa (tomas@cege.es)
-----
Last Modified:  Friday, 23rd May 2025 10:04:03 am
Modified By: Tomás (tomas@cege.es>)
-----
Copyright 2021 - 2022 Nousmedis, CeGe
-->
<table class="details-table" *ngIf="item" id="product-details-{{ item.id }}">
  <tbody>
    <!-- SKU -->
    <tr class="details-row">
      <td class="label">{{ "PRODUCT.SKU" | translate }}</td>
      <td class="value">{{ item.sku }}</td>
    </tr>

    <!-- Name -->
    <tr class="details-row">
      <td class="label">{{ "NAME" | translate }}</td>
      <td class="value">{{ item.name }}</td>
    </tr>

    <!-- Description -->
    <tr class="details-row">
      <td class="label">{{ "DESCRIPTION" | translate }}</td>
      <td class="value">{{ item.description }}</td>
    </tr>

    <!-- Family -->
    <tr class="details-row">
      <td class="label">{{ "PRODUCT.FAMILY" | translate }}</td>
      <td class="value">{{ item.family }}</td>
    </tr>

    <!-- Category -->
    <tr class="details-row">
      <td class="label">{{ "CATEGORY" | translate }}</td>
      <td class="value">{{ category?.name }}</td>
    </tr>

    <!-- Created At -->
    <tr class="details-row">
      <td class="label">{{ "CREATED_AT" | translate }}</td>
      <td class="value">{{ item.createdAt | date : "dd/MM/yyyy - HH:mm" }}</td>
    </tr>

    <!-- Tags -->
    <tr class="details-row">
      <td class="label">{{ "TAGS" | translate }}</td>
      <td class="value">
        <div class="tags-container">
          <p-tag *ngFor="let tag of item.tags" severity="info">{{ tag }}</p-tag>
        </div>
      </td>
    </tr>

    <!-- Extra Fields -->
    <ng-container *ngFor="let field of item.extraFields | keyvalue">
      <ng-container *ngIf="field.key != 'parent_category' && field.key != 'estatus'">
        <tr class="details-row">
          <td class="label">{{ field.key | titlecase }}</td>
          <td class="value">{{ field.value }}</td>
        </tr>
      </ng-container>
    </ng-container>
  </tbody>
</table>
